import { render, staticRenderFns } from "./metabolism.vue?vue&type=template&id=2eb699ca&scoped=true&"
import script from "./metabolism.vue?vue&type=script&lang=js&"
export * from "./metabolism.vue?vue&type=script&lang=js&"
import style0 from "./metabolism.vue?vue&type=style&index=0&id=2eb699ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb699ca",
  null
  
)

export default component.exports